<template>
    <add-edit-role></add-edit-role>
</template>

<script>

import vSelect from "vue-select";
import AddEditRole from "@/layouts/components/role-management/addedit-role.vue";

export default {
 components : {
   AddEditRole
 },
};
</script>